import BranchTicketsPerAgent from "../../../components/branches/reports/daily/BranchTicketsPerAgent";
import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import { REPORT_TYPE_IDS } from "../../../store/constants";
import { AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const DailyBranchTicketsPerAgent = ({ showFilterForm = true, showTitle = 1 }) => (
  <DailyGeneratedReportPage
    branchScoped={true}
    reportTypeId={REPORT_TYPE_IDS.daily_branch_tickets_per_agent}
    title="Tickets Per Agent"
    helmetTitle="Daily Branch Tickets Per Agent"
    descriptionKey="TicketsByAgents"
    columnDefinitions={AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS}
    defaultSortColumn="total"
    showFilterForm={showFilterForm}
    showTitle={showTitle}
  >
    {({ data, renderConfig, onRenderConfigChange }) => (
      <BranchTicketsPerAgent
        data={data}
        renderConfig={renderConfig}
        onRenderConfigChange={onRenderConfigChange}
      />
    )}
  </DailyGeneratedReportPage>
);

export default DailyBranchTicketsPerAgent;
